const TOKEN = 'token';
const EMPLOYEE_NO = 'employeeNo';

export const getAccessToken = () => localStorage.getItem(TOKEN);

export const setAccessToken = (token: string) => {
  // 工号由 userInfo 提供，清理旧版本留下的登录缓存。
  localStorage.removeItem(EMPLOYEE_NO);
  localStorage.setItem(TOKEN, token);
};

export const removeAccessToken = () => {
  localStorage.removeItem(TOKEN);
  localStorage.removeItem(EMPLOYEE_NO);
};
